<template>
  <div :class="['gallery-root', { 'dark-mode': isDarkMode }]">
    <!-- <p>gallery coming soon</p> -->

    <main class="gallery-scroll">
      <section
        v-for="item in galleryItems"
        :key="item.id"
        class="gallery-item"
      >
        <!-- <h2>{{ item.title }}</h2> -->
        <img
          :src="item.src"
          :alt="item.title"
          class="gallery-image"
          :class="item.orientation"
          loading="lazy"
        />
      </section>
    </main>
  </div>
</template>

<script>
import productImage from '../assets/product.png';
import step1Image from '../assets/step1.png';
import stufImage from '../assets/stuf.png';
import financImage from '../assets/financ.png';
import scoreImage from '../assets/score.png';

export default {
  name: 'Gallery',
  data() {
    return {
      isDarkMode: true,
      galleryItems: [
        { id: 'step1', title: 'Step 1', src: step1Image, orientation: 'portrait' },
        { id: 'stuf', title: 'Stuf', src: stufImage, orientation: 'landscape' },
        { id: 'product', title: 'Product', src: productImage, orientation: 'portrait' },
        { id: 'financ', title: 'Financ', src: financImage, orientation: 'landscape' },
        { id: 'score', title: 'Score', src: scoreImage, orientation: 'landscape' }
      ]
    };
  },
  mounted() {
    const savedTheme = localStorage.getItem('theme');
    this.isDarkMode = savedTheme !== 'light';
  }
};
</script>

<style scoped>
.gallery-root {
  min-height: 100vh;
  width: 100%;
  background: #ffffff;
  color: #111111;
  padding: 16px;
  box-sizing: border-box;
}

.gallery-root.dark-mode {
  background: #000000;
  color: #e6f5ee;
}

.gallery-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
}

.gallery-header h1 {
  margin: 0;
  font-size: 1.6rem;
}

.back-link {
  color: inherit;
  text-decoration: underline;
  font-weight: 700;
}

.gallery-scroll {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
}

.gallery-item {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.gallery-item h2 {
  margin: 0;
  width: 100%;
  max-width: 1200px;
  font-size: 1rem;
  opacity: 0.8;
}

.gallery-image {
  width: min(100vw - 32px, 1200px);
  max-width: 100%;
  object-fit: contain;
  border: 1px solid rgba(127, 127, 127, 0.35);
  border-radius: 8px;
  background: rgba(127, 127, 127, 0.08);
}

.gallery-image.landscape {
  height: clamp(220px, 50vw, 680px);
}

.gallery-image.portrait {
  width: min(82vw, 760px);
  height: clamp(300px, 72vw, 980px);
}

@media (max-width: 768px) {
  .gallery-root {
    padding: 12px;
  }

  .gallery-image {
    width: min(100vw - 24px, 100%);
  }

  .gallery-image.landscape {
    height: clamp(180px, 52vw, 420px);
  }

  .gallery-image.portrait {
    width: min(92vw, 100%);
    height: clamp(220px, 96vw, 560px);
  }
}
</style>
